/*
 * @Author: Tina Huang
 * @Date: 2024-08-06 13:44:44
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-25 16:47:49
 * @Description:
 */
import { balanceList, colors, reviewColors } from '@/constants/balance'
import { Button, Card, Tag, message, Image } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styles from './index.module.css'

export default function Balance() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [plan, setPlan] = useState<any>(null)
  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {
    if (id) {
      const year = Number(id?.split('-')[0]),
        n = id?.split('-')[1]
      const item = balanceList.find((y) => y.year === year)?.childs.find((cur) => cur.id === n)
      setPlan(item)
    }
  }, [id])

  const handleDetail = (year: number, item: any) => {
    if (item.status < 0) return messageApi.warning('该挑战计划尚未开始')
    navigate(`/how-to-balance/${year}-${item?.id}`)
  }

  const handleResp = () => {
    if (!plan || !plan?.link) return messageApi.error('报名链接已丢失')
    window.open(plan?.link)
  }

  if (id) {
    return (
      <div style={{ marginTop: '-1.25rem', marginLeft: '-3rem', marginRight: '-3rem' }}>
        <div style={{ height: 224 }} className="bg-black"></div>
        <h1 className="text-6xl text-white text-center" style={{ marginTop: -168 }}>
          {plan?.title}
        </h1>
        <p className="text-white text-center mt-2 text-xl">{plan?.date}</p>
        <div
          className="border p-4 bg-white rounded-lg shadow-lg w-1/2 m-auto"
          style={{ marginTop: 40, width: plan?.type === '复盘打卡' ? '80%' : '' }}
        >
          {plan?.status < 1 ? <h1 className="text-4xl text-center pt-10 pb-10">计划进行中...</h1> : <></>}
          {plan?.desc && <p dangerouslySetInnerHTML={{ __html: plan?.desc }}></p>}
          {plan?.type !== '复盘打卡' && (
            <Button shape="round" block type="primary" className="mt-5" disabled={plan?.status !== 0.1} onClick={handleResp}>
              我要报名
            </Button>
          )}
          {plan?.type === '复盘打卡' && (
            <div className="flex flex-wrap" style={{ marginLeft: -20 }}>
              {plan?.reviews.map((_item: any) => (
                <Card
                  hoverable
                  bordered
                  style={{ width: 240, marginLeft: 20, marginBottom: 10 }}
                  cover={<Image alt="example" src={_item.image} style={{ border: '1px solid #f0f0f0' }} />}
                >
                  <Card.Meta
                    title={
                      <>
                        <Tag color={reviewColors[_item.title.split('-')[0]]}>{_item.title.split('-')[0]}</Tag>
                        <span>{_item.title.split('-')[1]}</span>
                      </>
                    }
                  />
                </Card>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  }

  const ListCard = ({ item, handleDetail }: any) => {
    const type_color = colors[item?.type].color,
      rate = item.users / item.max
    return (
      <div
        className="border rounded-lg shadow-md cursor-pointer mb-3"
        style={{
          marginLeft: 12,
          width: 314,
          borderLeftWidth: 5,
          borderLeftColor: item.status >= 0 && item.status < 1 ? '#91caff' : item.status >= 1 ? '#c41d7f' : 'gray',
        }}
        onClick={handleDetail}
      >
        <h1 className="text-center text-4xl p-2 pt-8 pb-8 font-mono text-ellipsis max-w-full overflow-hidden whitespace-nowrap">
          {item.title}
        </h1>
        <div className="pt-2 pb-2 pl-4 pr-4 text-md">
          <p>
            <span style={{ color: type_color, fontWeight: 'bold' }}>{item?.type}</span>｜
            <Tag color={item.status >= 0 && item.status < 1 ? 'blue' : item.status > 0 ? 'pink' : 'gray'} className="mb-2">
              {item.status < 0
                ? '待开始'
                : item.status === 0
                ? '进行中'
                : item.status === 0.1
                ? '报名进行中'
                : item.status === 0.5
                ? '挑战进行中'
                : '已结束'}
            </Tag>
            {item.status > 0 ? `｜达标人数为${item.archived}${item.archived / item.users < 0.2 ? ' 😭' : ''}` : ''}
          </p>
          <p>时间：{item.date}</p>
          <p className="flex items-center mt-2">
            {item.type === '复盘打卡' || item.type === '学习打卡' ? '进度' : '报名'}：
            <span style={{ color: type_color, fontWeight: 'bold' }}>
              {item.users}/{item.max}
            </span>
            <span className={styles.progressBox} style={{ borderColor: type_color }}>
              <span
                className={styles.progressInner}
                style={{
                  background: type_color,
                  width: `${100 * rate}%`,
                }}
              ></span>
            </span>
          </p>
        </div>
      </div>
    )
  }

  const List = ({ list }: any) => {
    return (
      <div className="border p-4 bg-white rounded-lg shadow-md mb-4">
        <h3 className="text-xl font-mono font-bold">{list.year}</h3>
        <div className="pt-4 flex flex-wrap" style={{ marginLeft: -12 }}>
          {list.childs.map((item: any) => (
            <ListCard item={item} handleDetail={() => handleDetail(list.year, item)} />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div>
      {contextHolder}
      {balanceList.map((item) => (
        <List list={item} />
      ))}
    </div>
  )
}
